/* ═══════════════════════════════════════════════════════════════
   FrogMatch · Volume del Mese — runtime
   ───────────────────────────────────────────────────────────────
   Renderizza /pages/volume con i dati del mese precedente.
   Dipende da window.FrogMatch.computeVolumeData (in frogmatch.js).
   Share/save PNG via html2canvas (caricato come <script defer>).
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // ── helpers ─────────────────────────────────────────────────
  function $(sel, root) { return (root || document).querySelector(sel); }

  function prevMonthKey() {
    const now = new Date();
    let y = now.getFullYear();
    let m = now.getMonth(); // 0-based; oggi giugno=5 → vogliamo "YYYY-05" (maggio)
    if (m === 0) { y -= 1; m = 12; } // gennaio → dicembre anno prec.
    return y + '-' + String(m).padStart(2, '0');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // Bolda numeri/percentuali nelle annotazioni per dare ritmo tipografico.
  function formatNoteBold(text) {
    let s = escapeHtml(text);
    s = s.replace(/(\d+%)/g, '<strong>$1</strong>');
    s = s.replace(/(\d+(?:[.,]\d+)?\s*(?:nuov[ie]\s+mondi?|or[ae]|partit[ae]|giochi))/gi, '<strong>$1</strong>');
    return s;
  }

  // ── render dati nella card ────────────────────────────────
  function render(data, customerName) {
    // Header (1 sola riga Maggio 2026 a destra, no Frogger duplicato)
    $('[data-fm-vol-monthlabel]').textContent = data.monthLabel.toUpperCase();
    $('[data-fm-vol-froggername]').textContent = 'Frogger ' + customerName;
    $('[data-fm-vol-number]').textContent = String(data.volNumber || 1).padStart(2, '0');

    // Archetype subtitle (fallback gentile)
    let arch = '';
    try {
      const profile = window.FrogMatch.loadProfile();
      arch = window.FrogMatch.archetypeLabel(profile) || '';
    } catch (e) { arch = ''; }
    $('[data-fm-vol-archetype]').textContent = arch || 'Il tuo mese';

    // Hero SPLIT (cover quadrata + info accanto)
    const top = data.topGames[0] || null;
    if (top) {
      $('[data-fm-vol-hero-name]').textContent = top.name;
      $('[data-fm-vol-hero-count]').textContent = top.plays;
      const badgeLabel = $('[data-fm-vol-hero-badge-label]');
      if (badgeLabel) badgeLabel.textContent = top.plays === 1 ? 'partita' : 'partite';
      // Hero usa <img> tag (html2canvas più affidabile con img + CORS)
      if (top.cover) {
        applyHeroCover(top.cover);
      }
    }

    // Spine: TOP 12 giochi (oltre l'hero) = 4 col × 3 righe. Le copertine sono il pezzo
    // forte del Volume (foto-first), quindi parete piena; oltre, "+ N altri al tuo tavolo".
    const others = data.topGames.slice(1, 13);
    const extraCount = Math.max(0, data.topGames.length - 13); // hero + 12 spine = 13 mostrati
    const grid = $('[data-fm-vol-spines-grid]');
    const spinesBlock = $('[data-fm-vol-spines-block]');
    // Rimuovi eventuale label "+ N altri" da render precedente
    const oldMore = spinesBlock.querySelector('.fm-vol-spines-more');
    if (oldMore) oldMore.remove();
    if (others.length === 0) {
      spinesBlock.style.display = 'none';
    } else {
      grid.innerHTML = '';
      grid.style.gridTemplateColumns = 'repeat(' + Math.min(others.length, 4) + ', 1fr)';
      for (const g of others) {
        const spine = document.createElement('div');
        spine.className = 'fm-vol-spine';
        if (g.cover) {
          // <img> tag con fallback graceful (vedi setImageWithFallback)
          applySpineCover(spine, g.cover);
        } else {
          // No cover → nome al centro per identificare il gioco
          const nameEl = document.createElement('div');
          nameEl.className = 'fm-vol-spine-name';
          nameEl.textContent = g.name || '?';
          spine.appendChild(nameEl);
        }
        const num = document.createElement('div');
        num.className = 'fm-vol-spine-num';
        num.textContent = g.plays;
        spine.appendChild(num);
        grid.appendChild(spine);
      }
      // "+ N altri al tuo tavolo" se Andrea ha più giochi della top 5
      if (extraCount > 0) {
        const more = document.createElement('div');
        more.className = 'fm-vol-spines-more';
        more.textContent = '+ ' + extraCount + (extraCount === 1 ? ' altro al tuo tavolo' : ' altri al tuo tavolo');
        spinesBlock.appendChild(more);
      }
    }

    // Stats (3 pulite: Partite · Giochi · Nuovi). Niente "vs media" — confondeva.
    $('[data-fm-vol-stat-partite]').textContent = data.partite;
    $('[data-fm-vol-stat-giochi]').textContent = data.giochi;
    $('[data-fm-vol-stat-nuovi]').textContent = data.nuovi;

    // TITOLO DEL MESE: un solo headline editoriale forte (sostituisce la vecchia lista
    // di annotazioni). textContent = niente rischio injection sui nomi giochi.
    const notesEl = $('[data-fm-vol-notes]');
    notesEl.innerHTML = '';
    if (data.title && data.title.headline) {
      const box = document.createElement('div');
      box.className = 'fm-vol-title';
      const k = document.createElement('div');
      k.className = 'fm-vol-title-kicker';
      k.textContent = 'Il titolo del mese';
      box.appendChild(k);
      const h = document.createElement('div');
      h.className = 'fm-vol-title-head';
      h.textContent = data.title.headline;
      box.appendChild(h);
      if (data.title.sub) {
        const s = document.createElement('div');
        s.className = 'fm-vol-title-sub';
        s.textContent = data.title.sub;
        box.appendChild(s);
      }
      notesEl.appendChild(box);
    }

    // Footer: solo brand fisso, niente da popolare runtime (Vol+mese sono nell'header)
  }

  // ── fetch BGG su-demand per cover hero mancanti ──────────
  // v2: cache key bump per invalidare entries vecchie senza imgFull HD.
  // Senza questo, le entry localStorage vecchie hanno solo thumbnail e
  // l'export PNG le upscala pesantemente → sfocato.
  const BGG_THUMB_CACHE_KEY = 'frogmatch_bgg_thumbs_v2';
  function readThumbCache() {
    try { return JSON.parse(localStorage.getItem(BGG_THUMB_CACHE_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function writeThumbCache(cache) {
    try { localStorage.setItem(BGG_THUMB_CACHE_KEY, JSON.stringify(cache)); }
    catch (e) {}
  }
  // Worker URL: HARDCODED il worker froghunt che ha gli endpoint BGG/img-proxy.
  // Andrea aveva settato per errore "stagno-release.info-frogames.workers.dev"
  // nell'admin Volume → URL malformato senza schema, browser interpreta come
  // path relativo a /pages/, tutto 404. Hardcode è più sicuro: 1 worker per
  // tutto FrogMatch. Se in futuro cambia, modifica qui o aggiungi override
  // nei settings (ma richiede schema https:// e validazione).
  const WORKER_URL_HARDCODED = 'https://froghunt.info-frogames.workers.dev';

  function getWorkerUrl() {
    // Tenta di leggere setting solo se è un URL valid completo
    const pageEl = $('[data-fm-volume-page]');
    const setting = pageEl && pageEl.dataset.workerUrl ? pageEl.dataset.workerUrl : '';
    if (/^https?:\/\/[a-z0-9-]+\.workers\.dev(\/|$)/i.test(setting)) {
      return setting;
    }
    // Fallback: l'hardcoded fidato
    return WORKER_URL_HARDCODED;
  }

  // Passa le URL BGG attraverso /api/img-proxy (CORS aperto) per consentire
  // html2canvas di catturarle nell'export PNG. Le immagini BGG dirette
  // hanno Access-Control-Allow-Origin assente → html2canvas le rendera vuote.
  function viaProxy(originalUrl) {
    if (!originalUrl) return originalUrl;
    if (!/^https?:\/\/cf\.geekdo-images\.com\//i.test(originalUrl)) return originalUrl;
    const workerUrl = getWorkerUrl();
    if (!workerUrl) return originalUrl;
    return workerUrl.replace(/\/$/, '') + '/api/img-proxy?url=' + encodeURIComponent(originalUrl);
  }

  // STRATEGIA DISPLAY/EXPORT SEPARATA:
  // - Display normale: <img> senza crossorigin → veloce, no CORS headache
  // - Export PNG: prepareImagesForExport() ricarica src con crossorigin
  //   appena prima di html2canvas (vedi sotto)
  // Salva original URL nel dataset per il prepare successivo.
  function setImageWithFallback(imgEl, originalUrl) {
    if (!imgEl || !originalUrl) return;
    const proxiedUrl = viaProxy(originalUrl);
    imgEl.removeAttribute('crossorigin');
    imgEl.dataset.originalUrl = originalUrl;
    imgEl.dataset.proxiedUrl = proxiedUrl;
    imgEl.onerror = function () {
      // Proxy fail → fallback URL BGG diretto (display only)
      if (imgEl.src !== originalUrl) {
        imgEl.onerror = null;
        imgEl.src = originalUrl;
      } else {
        imgEl.onerror = null;
        imgEl.hidden = true;
      }
    };
    imgEl.src = proxiedUrl;
  }

  function applyHeroCover(thumb) {
    const heroEl = $('[data-fm-vol-hero-cover]');
    if (!heroEl) return;
    let imgEl = heroEl.querySelector('[data-fm-vol-hero-img]');
    if (imgEl) {
      imgEl.hidden = false;
      setImageWithFallback(imgEl, thumb);
    } else {
      heroEl.style.backgroundImage = "url('" + viaProxy(thumb) + "')";
    }
    heroEl.setAttribute('data-has-img', 'true');
  }
  function applySpineCover(spineEl, thumb) {
    if (!spineEl) return;
    let imgEl = spineEl.querySelector('.fm-vol-spine-img');
    if (!imgEl) {
      imgEl = document.createElement('img');
      imgEl.className = 'fm-vol-spine-img';
      imgEl.alt = '';
      spineEl.insertBefore(imgEl, spineEl.firstChild);
      const nameEl = spineEl.querySelector('.fm-vol-spine-name');
      if (nameEl) nameEl.remove();
    }
    setImageWithFallback(imgEl, thumb);
    spineEl.setAttribute('data-has-img', 'true');
  }

  // Persiste cover trovata via fetch ANCHE nel profile localStorage.
  // Side-effect importante: la ludoteca del Frogger Profile vedrà la cover
  // alla prossima apertura, senza dover risincronizzare la collection BGG.
  // Match per bggId (preciso) o per name normalizzato (fallback).
  function persistCoverToProfile(name, thumb, bggIdHint) {
    if (!thumb || !window.FrogMatch || !window.FrogMatch.loadProfile || !window.FrogMatch.saveProfile) return;
    const profile = window.FrogMatch.loadProfile();
    if (!profile) return;
    const norm = function (s) { return (s || '').toLowerCase().trim(); };
    const nameKey = norm(name);
    let touched = false;

    // 1) bggCollection.owned[] (ludoteca BGG sync)
    if (profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
      for (const item of profile.bggCollection.owned) {
        if (!item || typeof item !== 'object') continue;
        const idMatch = bggIdHint && item.id === bggIdHint;
        const nameMatch = nameKey && norm(item.name) === nameKey;
        if ((idMatch || nameMatch) && !item.thumbnail) {
          item.thumbnail = thumb;
          touched = true;
        }
      }
    }
    // 2) manualPlays[] (partite loggate)
    if (Array.isArray(profile.manualPlays)) {
      for (const mp of profile.manualPlays) {
        if (!mp) continue;
        const idMatch = bggIdHint && mp.bggId === bggIdHint;
        const nameMatch = nameKey && norm(mp.title) === nameKey;
        if ((idMatch || nameMatch) && !mp.img) {
          mp.img = thumb;
          touched = true;
        }
      }
    }
    // 3) manualOwned[] (ludoteca manuale) — shape è {title}, NON {name}
    if (Array.isArray(profile.manualOwned)) {
      for (const mo of profile.manualOwned) {
        if (!mo) continue;
        const moName = mo.title || mo.name;
        const idMatch = bggIdHint && mo.bggId === bggIdHint;
        const nameMatch = nameKey && norm(moName) === nameKey;
        if ((idMatch || nameMatch) && !mo.img) {
          mo.img = thumb;
          touched = true;
        }
      }
    }
    // 3.5) purchasedProducts[] (acquistati da Frogames senza img)
    if (Array.isArray(profile.purchasedProducts)) {
      for (const pp of profile.purchasedProducts) {
        if (!pp) continue;
        const ppName = pp.title || pp.name;
        const idMatch = bggIdHint && pp.bggId === bggIdHint;
        const nameMatch = nameKey && norm(ppName) === nameKey;
        if ((idMatch || nameMatch) && !pp.img) {
          pp.img = thumb;
          touched = true;
        }
      }
    }
    // 4) playsActivity.topPlayed[] (top played BGG sync)
    if (profile.playsActivity && Array.isArray(profile.playsActivity.topPlayed)) {
      for (const tp of profile.playsActivity.topPlayed) {
        if (!tp) continue;
        const idMatch = bggIdHint && tp.bggId === bggIdHint;
        const nameMatch = nameKey && norm(tp.name) === nameKey;
        if ((idMatch || nameMatch) && !tp.img) {
          tp.img = thumb;
          touched = true;
        }
      }
    }

    if (touched) {
      try {
        window.FrogMatch.saveProfile(profile);
        console.info('[Volume] cover salvata in profile per "' + name + '"');
      } catch (e) { /* localStorage quota / other */ }
    }
  }
  // Ritorna { img, imgFull, bggId } — imgFull per hero retina, img per spine.
  async function fetchBggThumb(name, workerUrl, bggIdHint) {
    if (!workerUrl) return null;
    const base = workerUrl.replace(/\/$/, '');

    // STRADA 1 (preferita): /api/bgg-thumb-by-id se ho bggId.
    if (bggIdHint) {
      try {
        const res = await fetch(base + '/api/bgg-thumb-by-id?id=' + bggIdHint);
        if (res.ok) {
          const json = await res.json();
          if (json && json.img) {
            console.info('[Volume] thumb-by-id OK per "' + name + '" →', json.name);
            return { img: json.img, imgFull: json.imgFull || null, bggId: json.bggId || bggIdHint };
          }
        }
      } catch (e) { /* fallback */ }
    }

    // STRADA 2: /api/bgg-thumb-by-name (bridge search → thing).
    if (!name) return null;
    try {
      const res = await fetch(base + '/api/bgg-thumb-by-name?q=' + encodeURIComponent(name));
      if (res.ok) {
        const json = await res.json();
        if (json && json.img) {
          console.info('[Volume] thumb-by-name OK per "' + name + '" →', json.name);
          return { img: json.img, imgFull: json.imgFull || null, bggId: json.bggId || null };
        }
        console.warn('[Volume] thumb-by-name: nessuna img per "' + name + '"', json && json.reason);
      } else {
        console.warn('[Volume] thumb-by-name HTTP', res.status, 'per "' + name + '"');
      }
    } catch (e) {
      console.warn('[Volume] thumb-by-name fetch error per "' + name + '":', e && e.message);
    }

    // SECONDA STRADA (fallback): /api/bgg-search con iterazione top 5
    try {
      const res = await fetch(base + '/api/bgg-search?q=' + encodeURIComponent(name));
      if (!res.ok) return null;
      const json = await res.json();
      const results = (json && Array.isArray(json.results)) ? json.results
                    : (Array.isArray(json) ? json : []);
      if (results.length === 0) return null;
      for (let i = 0; i < Math.min(results.length, 5); i++) {
        const r = results[i];
        const thumb = r.img || r.thumbnail || r.image;
        if (thumb) {
          console.info('[Volume] bgg-search fallback OK per "' + name + '" (pos ' + (i + 1) + ')');
          return { img: thumb, bggId: r.bggId || null };
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  }
  async function tryEnrichMissingCovers(data) {
    const pageEl = $('[data-fm-volume-page]');
    const workerUrl = pageEl && pageEl.dataset.workerUrl ? pageEl.dataset.workerUrl : '';
    if (!workerUrl) return;

    const cache = readThumbCache();
    let cacheDirty = false;

    // Cache hit = { img, bggId } object; backward compat con stringa diretta (vecchia cache)
    function fromCache(v) {
      if (!v) return null;
      if (typeof v === 'string') return { img: v, imgFull: null, bggId: null };
      return v;
    }
    function toCache(o) { return { img: o.img, imgFull: o.imgFull || null, bggId: o.bggId || null }; }

    // Hero (top game) — SEMPRE prova upgrade a imgFull anche se la thumbnail
    // è già nel profile (top.cover = thumbnail BGG salvata). Su retina la
    // thumbnail (~200px) si vede sgranata nell'hero grande.
    const top = data.topGames[0];
    if (top) {
      const nameKey = (top.name || '').toLowerCase().trim();
      const cached = fromCache(cache[nameKey]);
      let result = cached;
      // Refetch se cache non ha imgFull (es. cache pre-bump vecchia)
      if (!result || !result.imgFull) {
        const fresh = await fetchBggThumb(top.name, workerUrl, top.bggId);
        if (fresh) {
          result = fresh;
          cache[nameKey] = toCache(result);
          cacheDirty = true;
        }
      }
      if (result) {
        // Hero usa imgFull (HD) se disponibile, fallback img/thumbnail
        const heroSrc = result.imgFull || result.img;
        if (heroSrc) applyHeroCover(heroSrc);
        if (result.img) {
          persistCoverToProfile(top.name, result.img, result.bggId || top.bggId);
        }
      }
    }

    // Spine (giochi 2-9): SEMPRE prova upgrade a imgFull anche se cover thumbnail già presente.
    const spineEls = document.querySelectorAll('[data-fm-vol-spines-grid] .fm-vol-spine');
    const others = data.topGames.slice(1, 9);
    for (let i = 0; i < others.length; i++) {
      const g = others[i];
      const spineEl = spineEls[i];
      if (!g || !spineEl) continue;
      const nameKey = (g.name || '').toLowerCase().trim();
      const cached = fromCache(cache[nameKey]);
      let result = cached;
      // Refetch se cache non ha imgFull (per HD)
      if (!result || !result.imgFull) {
        const fresh = await fetchBggThumb(g.name, workerUrl, g.bggId);
        if (fresh) {
          result = fresh;
          cache[nameKey] = toCache(result);
          cacheDirty = true;
        }
      }
      if (result) {
        const spineSrc = result.imgFull || result.img || g.cover;
        if (spineSrc) applySpineCover(spineEl, spineSrc);
        if (result.img) {
          persistCoverToProfile(g.name, result.img, result.bggId || g.bggId);
        }
      }
    }

    if (cacheDirty) writeThumbCache(cache);
  }

  // ── render via html-to-image (SVG foreignObject) ─────────
  async function waitForHtmlToImage(maxMs) {
    const start = Date.now();
    while (!window.htmlToImage || !window.htmlToImage.toPng) {
      if (Date.now() - start > (maxMs || 4000)) {
        throw new Error('html-to-image non caricato');
      }
      await new Promise(function (r) { setTimeout(r, 100); });
    }
  }

  // PRIMA dell'export PNG: scarica ogni <img> della card via fetch, converte
  // la response in base64 data URI, sostituisce src. Le data URI sono
  // same-origin → html2canvas NON PUO' fallire né taintare il canvas.
  //
  // Soluzione bulletproof. Più lenta (transfer + base64) ma sicura al 100%
  // perché bypassa CORS completamente: una volta che la response è in
  // base64 dentro la pagina, il browser la tratta come local data.
  function blobToDataURI(blob) {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();
      reader.onloadend = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function fetchImageAsDataUri(url) {
    let target = url;
    if (/^https?:\/\/cf\.geekdo-images\.com\//i.test(url)) {
      target = getWorkerUrl().replace(/\/$/, '') + '/api/img-proxy?url=' + encodeURIComponent(url);
    }
    const sep = target.includes('?') ? '&' : '?';
    const fresh = target + sep + '_fresh=' + Date.now();
    const res = await fetch(fresh, { mode: 'cors', credentials: 'omit' });
    if (!res.ok) throw new Error('fetch ' + res.status);
    const blob = await res.blob();
    if (!blob.type.startsWith('image/')) throw new Error('not an image: ' + blob.type);
    return await blobToDataURI(blob);
  }

  // Resize data URI a dimensione target via Canvas API.
  // CRUCIALE per html2canvas: immagini HD 1500-2000px causano artifact
  // di render (linee/tile distorted) quando processate a scale 3.
  // Resize a dimensione adeguata al display target (max 800px per hero,
  // 400px per spine) elimina il problema mantenendo nitidezza.
  async function resizeDataUri(dataUri, maxDim, quality) {
    return new Promise(function (resolve) {
      const img = new Image();
      img.onload = function () {
        const w = img.naturalWidth || img.width;
        const h = img.naturalHeight || img.height;
        const longest = Math.max(w, h);
        if (longest <= maxDim) return resolve(dataUri); // già piccola
        const ratio = maxDim / longest;
        const newW = Math.round(w * ratio);
        const newH = Math.round(h * ratio);
        try {
          const canvas = document.createElement('canvas');
          canvas.width = newW;
          canvas.height = newH;
          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, newW, newH);
          resolve(canvas.toDataURL('image/jpeg', quality || 0.92));
        } catch (e) {
          resolve(dataUri); // canvas tainted o altro errore → originale
        }
      };
      img.onerror = function () { resolve(dataUri); };
      img.src = dataUri;
    });
  }

  async function prepareImagesForExport() {
    const card = $('[data-fm-volume-card]');
    if (!card) return 0;
    const imgs = Array.from(card.querySelectorAll('img'));
    let success = 0, failed = 0;
    // Sequenziale per non sovraccaricare il worker
    for (const img of imgs) {
      if (img.hidden) continue;
      if (img.src && img.src.startsWith('data:')) { success++; continue; }
      const sourceUrl = img.dataset.originalUrl || img.src;
      if (!sourceUrl) continue;
      try {
        const rawDataUri = await fetchImageAsDataUri(sourceUrl);
        // Dimensioni adeguate al render finale (pixelRatio 4, forceWidth 540):
        // Hero ~240 logical × 4 = ~960 pixel. Spine ~100 logical × 4 = 400 pixel.
        // Margine generoso: hero max 1200px, spine max 600px → niente upscale.
        const isHero = img.classList.contains('fm-vol-hero-cover-img') ||
                       (img.parentElement && img.parentElement.classList &&
                        img.parentElement.classList.contains('fm-vol-hero-cover'));
        const maxDim = isHero ? 1200 : 600;
        const resized = await resizeDataUri(rawDataUri, maxDim, 0.95);
        img.removeAttribute('crossorigin');
        img.src = resized;
        if (!img.complete) {
          await new Promise(function (r) {
            const done = function () { r(); };
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
            setTimeout(done, 2000);
          });
        }
        success++;
      } catch (e) {
        console.warn('[Volume] base64 fail per', sourceUrl, '→', e.message);
        failed++;
      }
    }
    console.info('[Volume] prepare PNG: ' + success + ' OK, ' + failed + ' fail');
    return success;
  }

  // Aspetta che TUTTI i font del documento siano caricati e parsati.
  // Bug Andrea: "FlipToons" sdoppiato/sfasato nel PNG perché html2canvas
  // scatta prima che Fraunces (Google Font) sia disponibile → fallback
  // serif system con metrica diversa → glifi che si sovrappongono.
  async function waitForFontsReady() {
    if (document.fonts && document.fonts.ready) {
      try { await document.fonts.ready; } catch (e) {}
      // Forza load specifico dei font usati nella card
      try {
        await Promise.all([
          document.fonts.load('700italic 22px "Fraunces"'),
          document.fonts.load('900 60px "Fraunces"'),
          document.fonts.load('400italic 18px "Fraunces"'),
          document.fonts.load('600 13px "Inter"')
        ]);
      } catch (e) {}
    }
  }

  async function renderCardToBlob() {
    await waitForHtmlToImage();
    await waitForFontsReady();
    await prepareImagesForExport();
    const card = $('[data-fm-volume-card]');

    // html-to-image opzioni:
    // - pixelRatio: 3 (equivalente scale 3 html2canvas, qualità retina)
    // - cacheBust: true (forza fetch immagini fresche, no cache HTTP issues)
    // - filter: skip script/style/custom elements del theme che crashano
    // - skipFonts: false (NON skip — vogliamo Fraunces caricato come SVG)
    // - width/height: forza dimensione desktop per qualità su mobile
    // NITIDEZZA + LAYOUT INTATTO: clono la card dentro un wrapper con la
    // classe fm-volume-page così le CSS variables (--fmv-paper, --fmv-ink, ecc.)
    // si risolvono correttamente. Senza wrapper il clone esce NERO perché
    // le variabili definite in .fm-volume-page non sono nel scope di body.
    const wrapper = document.createElement('div');
    wrapper.className = 'fm-volume-page';
    wrapper.style.position = 'absolute';
    wrapper.style.left = '-9999px';
    wrapper.style.top = '0';
    wrapper.style.width = '540px';
    wrapper.style.padding = '0';
    wrapper.style.minHeight = '0';
    wrapper.style.background = 'transparent'; // override fm-volume-page bg dark

    const clone = card.cloneNode(true);
    clone.style.width = '540px';
    clone.style.maxWidth = '540px';
    clone.style.minWidth = '540px';
    clone.style.margin = '0';
    clone.style.transform = 'none';
    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);

    // Doppio rAF: aspetta che browser layout + paint completi sul clone
    await new Promise(function (r) {
      requestAnimationFrame(function () {
        requestAnimationFrame(r);
      });
    });

    let dataUrl;
    try {
      dataUrl = await window.htmlToImage.toPng(clone, {
        pixelRatio: 4, // output 2160 wide (540 × 4) = match IG Stories ×2
        cacheBust: true,
        filter: function (node) {
          if (!node.tagName) return true;
          const tag = node.tagName.toUpperCase();
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return false;
          if (node.tagName.indexOf('-') !== -1 && node.tagName !== 'FM-VOL-CARD') return false;
          return true;
        }
      });
    } finally {
      // Rimuovi wrapper offscreen (anche se errore)
      if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
    }

    const fetchRes = await fetch(dataUrl);
    return await fetchRes.blob();
  }

  // Legacy alias per non rompere riferimenti esistenti
  async function renderCardToCanvas() {
    return await renderCardToBlob();
  }

  // OLD html2canvas function PRESERVED in case fallback needed
  async function _renderCardToCanvas_html2canvas() {
    await waitForFontsReady();
    await prepareImagesForExport();
    const card = $('[data-fm-volume-card]');

    // ignoreElements: skip custom elements PRIMA che vengano clonati.
    // I custom elements del theme (predictive-search, footer-details,
    // accordion-details) hanno constructor che cercano querySelector e
    // crashano quando il clone non è ancora nel DOM. ignoreElements è
    // chiamato durante il clone, prima dell'attivazione constructor.
    const SKIP_TAGS = ['SCRIPT', 'STYLE', 'NOSCRIPT',
                       'PREDICTIVE-SEARCH', 'FOOTER-DETAILS', 'ACCORDION-DETAILS',
                       'HEADER-COMPONENT', 'THEME-HEADER', 'CART-DRAWER',
                       'MOBILE-NAV', 'PRODUCT-FORM', 'QUANTITY-INPUT',
                       'MODAL-DIALOG', 'PROMO-BAR', 'SLIDER-COMPONENT'];

    return await window.html2canvas(card, {
      backgroundColor: null,
      scale: 3,
      useCORS: true,
      allowTaint: false,
      logging: false,
      imageTimeout: 10000,
      removeContainer: true,
      foreignObjectRendering: false,
      ignoreElements: function (element) {
        if (!element || !element.tagName) return false;
        if (SKIP_TAGS.indexOf(element.tagName) !== -1) return true;
        if (element.tagName.indexOf('-') !== -1) return true;
        return false;
      },
      onclone: function (clonedDoc) {
        try {
          const cardClone = clonedDoc.querySelector('[data-fm-volume-card]');
          if (!cardClone) return;

          // ─── FIX QUALITÀ: forza render a dimensione desktop ───
          // Su mobile la card è 340px → export 1020px. Forzando 450px
          // l'export diventa 1350px → ~30% di pixel in più → più nitido
          // su display di destinazione (IG Stories 1080w nativa).
          const overrideStyle = clonedDoc.createElement('style');
          overrideStyle.textContent =
            '[data-fm-volume-card] { width: 450px !important; max-width: 450px !important; }' +
            '/* override media query mobile per nitidezza */' +
            '@media (max-width: 480px) {' +
            '  [data-fm-volume-card] { width: 450px !important; max-width: 450px !important; }' +
            '  .fm-vol-head { padding: 20px 24px 10px !important; }' +
            '  .fm-vol-number { font-size: 52px !important; }' +
            '  .fm-vol-month { font-size: 18px !important; }' +
            '}' +
            /* Anti-aliasing testo per render canvas nitido */
            '[data-fm-volume-card], [data-fm-volume-card] * {' +
            '  -webkit-font-smoothing: antialiased;' +
            '  -moz-osx-font-smoothing: grayscale;' +
            '  text-rendering: geometricPrecision;' +
            '}';
          clonedDoc.head.appendChild(overrideStyle);

          // BUG 1 html2canvas #725: object-fit cover ignorato.
          // Fix: img → div background-image (html2canvas supporta bg-size).
          const imgs = cardClone.querySelectorAll('img');
          imgs.forEach(function (img) {
            if (img.hidden || !img.src) return;
            const parent = img.parentElement;
            if (!parent) return;
            const isSpine = parent.classList && parent.classList.contains('fm-vol-spine');
            parent.style.backgroundImage = "url('" + img.src + "')";
            parent.style.backgroundSize = isSpine ? 'cover' : 'contain';
            parent.style.backgroundPosition = isSpine ? 'center top' : 'center';
            parent.style.backgroundRepeat = 'no-repeat';
            img.style.display = 'none';
          });

          // BUG 2 html2canvas #1940: webfont + scale = double render.
          // Fix: Georgia inline style su testi critici (max specificità).
          const heroTitle = cardClone.querySelector('.fm-vol-hero-title');
          if (heroTitle) {
            heroTitle.style.fontFamily = 'Georgia, "Times New Roman", serif';
            heroTitle.style.fontFeatureSettings = 'normal';
            heroTitle.style.letterSpacing = '0';
          }
          const heroBadge = cardClone.querySelector('.fm-vol-hero-badge');
          if (heroBadge) {
            heroBadge.style.fontFamily = 'Georgia, "Times New Roman", serif';
            heroBadge.style.fontFeatureSettings = 'normal';
          }
        } catch (e) {
          console.warn('[Volume] onclone error', e);
        }
      }
    });
  }

  // ── save PNG (html-to-image ritorna Blob direttamente) ────
  async function savePNG() {
    const btn = $('[data-fm-vol-save]');
    const label = btn.querySelector('.fm-volume-action__label');
    const originalLabel = label.textContent;
    btn.disabled = true;
    label.textContent = 'Genero...';

    try {
      const blob = await renderCardToBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'frogames-volume-' + prevMonthKey() + '.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
      label.textContent = 'Salvato ✓';
    } catch (e) {
      console.error('[Volume] save error', e);
      label.textContent = 'Errore';
    } finally {
      setTimeout(function () {
        label.textContent = originalLabel;
        btn.disabled = false;
      }, 1800);
    }
  }

  // ── share nativo (Web Share API + files) ──────────────────
  async function shareNative() {
    const btn = $('[data-fm-vol-share]');
    btn.disabled = true;
    try {
      const blob = await renderCardToBlob();
      const file = new File(
        [blob],
        'frogames-volume-' + prevMonthKey() + '.png',
        { type: 'image/png' }
      );
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Il mio Volume del Mese',
          text: 'Il riepilogo delle mie partite — FroGames'
        });
      } else if (navigator.share) {
        await navigator.share({
          title: 'Il mio Volume del Mese',
          text: 'Il riepilogo delle mie partite — FroGames',
          url: window.location.href
        });
      }
    } catch (e) {
      if (e && e.name !== 'AbortError') console.error('[Volume] share error', e);
    } finally {
      btn.disabled = false;
    }
  }

  // ── init ──────────────────────────────────────────────────
  function init(retries) {
    retries = retries || 0;
    const wrap = $('[data-fm-volume-wrap]');
    const loading = $('[data-fm-volume-loading]');
    const nodata = $('[data-fm-volume-nodata]');

    // Pagina senza customer loggato — non c'è loading/wrap, esci.
    if (!wrap && !loading) return;

    // Aspetta che FrogMatch sia carico (script tag order safety)
    if (!window.FrogMatch || !window.FrogMatch.computeVolumeData) {
      if (retries > 30) {
        console.error('[Volume] FrogMatch non caricato dopo 30 retry');
        if (loading) loading.hidden = true;
        if (nodata) nodata.hidden = false;
        return;
      }
      setTimeout(function () { init(retries + 1); }, 150);
      return;
    }

    // Finestra "primi 5 giorni del mese": dopo il 5 il Volume sparisce dalla vista
    // (stato "chiuso"). Torna il 1° del mese successivo col nuovo numero.
    if (new Date().getDate() > 5) {
      if (loading) loading.hidden = true;
      if (wrap) wrap.hidden = true;
      if (nodata) {
        nodata.hidden = false;
        const icon = nodata.querySelector('.fm-volume-nodata__icon');
        const ttl = nodata.querySelector('.fm-volume-nodata__title');
        const txt = nodata.querySelector('[data-fm-volume-nodata-text]');
        const hint = nodata.querySelector('.fm-volume-nodata__hint');
        if (icon) icon.textContent = '📕';
        if (ttl) ttl.textContent = 'Volume chiuso';
        if (txt) txt.textContent = 'Il riepilogo del mese si sfoglia solo nei primi 5 giorni.';
        if (hint) hint.textContent = 'Torna il 1° del mese prossimo per il nuovo numero. 🐸';
      }
      return;
    }

    const customer = window.FrogMatchVolumeCustomer || {};
    const customerName = customer.name || 'Frogger';
    const monthKey = prevMonthKey();

    let data;
    try {
      data = window.FrogMatch.computeVolumeData(monthKey);
    } catch (e) {
      console.error('[Volume] compute error', e);
      if (loading) loading.hidden = true;
      if (nodata) nodata.hidden = false;
      return;
    }

    if (!data.hasData) {
      if (loading) loading.hidden = true;
      if (nodata) nodata.hidden = false;
      const txt = $('[data-fm-volume-nodata-text]');
      if (txt) txt.textContent = 'Nessuna partita registrata a ' + data.monthLabel + '.';
      return;
    }

    render(data, customerName);
    if (loading) loading.hidden = true;
    wrap.hidden = false;

    // Debug bootstrap dettagliato: per ogni gioco senza cover, mostra nome + bggId.
    // Aiuta a capire CHI è il gioco senza cover (es. "logged a mano senza bggId").
    const pageEl = $('[data-fm-volume-page]');
    const workerUrl = pageEl && pageEl.dataset.workerUrl ? pageEl.dataset.workerUrl : '';
    const missingCovers = data.topGames.filter(function (g) { return !g.cover; });
    console.info('[Volume] Bootstrap →',
      'mese=' + monthKey,
      'Vol=' + data.volNumber,
      'partite=' + data.partite,
      'giochi=' + data.giochi,
      'workerUrl=' + (workerUrl ? 'OK' : 'MANCANTE!'),
      'cover OK=' + (data.topGames.length - missingCovers.length) + '/' + data.topGames.length
    );
    if (missingCovers.length > 0) {
      console.group('[Volume] Cover mancanti — dettaglio per debug');
      missingCovers.forEach(function (g) {
        console.log('· "' + g.name + '"',
          'bggId=' + (g.bggId || 'NULL (loggato senza BGG search!)'),
          'partite=' + g.plays
        );
      });
      console.groupEnd();
    }
    if (!workerUrl && missingCovers.length > 0) {
      console.warn('[Volume] worker_url non configurato in admin section → niente fetch BGG su-demand. Imposta in: Online Store → Customize → Pages → Volume del Mese → FrogMatch Volume → Cloudflare Worker URL');
    }

    // Arricchimento async: pesca cover BGG mancanti via worker /api/bgg-search
    tryEnrichMissingCovers(data);

    // Bind azioni
    const saveBtn = $('[data-fm-vol-save]');
    if (saveBtn) saveBtn.addEventListener('click', savePNG);

    if (navigator.share) {
      const shareBtn = $('[data-fm-vol-share]');
      if (shareBtn) {
        shareBtn.hidden = false;
        shareBtn.addEventListener('click', shareNative);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
